import DonorsPanel from './DonorsPanel';

export default DonorsPanel;
